import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, importProvidersFrom, LOCALE_ID, ErrorHandler, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { routes } from './app.routes';
import { pt_BR, provideNzI18n } from 'ng-zorro-antd/i18n';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NZ_ICONS } from 'ng-zorro-antd/icon';
import {
  CloudOutline,
  PlusOutline,
  LoadingOutline,
  CheckOutline,
  DeleteOutline,
  ArrowRightOutline,
  CalendarOutline,
  EyeOutline,
  EyeInvisibleOutline,
  SaveOutline,
  CopyOutline,
  ShopOutline,
  MessageOutline,
  CloseOutline,
  ReloadOutline,
  SwapOutline,
  CarOutline,
  ToolOutline,
  ExclamationCircleOutline,
  ArrowDownOutline,
  PercentageOutline
} from '@ant-design/icons-angular/icons';
import { registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authTokenInterceptor } from './core/interceptors/auth-token-interceptor';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { FeatureFlagsService } from './core/services/feature-flags.service';
import { SessionStorageService } from './core/services/session-storage.service';

import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt, 'pt-BR');

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideNzI18n(pt_BR),
    importProvidersFrom(FormsModule, NzModalModule),
    provideAnimationsAsync(),
    provideEnvironmentNgxMask(),
    provideHttpClient(
      withInterceptors([authTokenInterceptor]),
    ),
    {
      provide: NZ_ICONS, useValue: [
        CloudOutline, PlusOutline, LoadingOutline, CheckOutline, DeleteOutline, ArrowRightOutline,
        CalendarOutline, EyeOutline, EyeInvisibleOutline, SaveOutline, CopyOutline, ShopOutline,
        MessageOutline, CloseOutline, ReloadOutline, SwapOutline, CarOutline, ToolOutline,
        ExclamationCircleOutline, ArrowDownOutline, PercentageOutline
      ]
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
    provideAppInitializer(() => { inject(Sentry.TraceService); }),
    provideAppInitializer(async () => {
      try {
        if (inject(SessionStorageService).getItem('auth')) {
          await inject(FeatureFlagsService).load();
        }
      } catch { /* flags opcionais em rotas públicas */ }
    }),
  ]
};
